// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-xxlargeOnConfined-superElipse-48c1be38","strokeWidth":"super-ellipse-skins-xxlargeOnConfined-strokeWidth-74739252"};